import { render, staticRenderFns } from "./USPSVertical.vue?vue&type=template&id=519f314c&scoped=true"
import script from "./USPSVertical.vue?vue&type=script&lang=js"
export * from "./USPSVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519f314c",
  null
  
)

export default component.exports